import { React, useState } from "react";
import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import CancelIcon from "@mui/icons-material/Cancel";
import Image from "../../../images/verifiedModal.png";
import { InputAdornment, TextField } from "@mui/material";
import { Link } from "react-router-dom";
import SmartPinModal from "./smartPinModal";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  maxWidth: 525,
  width:"100%",
  minWidth: "303px!important",
  "@media(max-width:600px)":{width:"303px!important"},
  bgcolor: "#FFFFFF",
  borderRadius: "24px",
  boxShadow: 24,
  p: "1rem 1.4rem ",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
};

export default function VerifiedModal(props) {
  // Modal use State
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  
  // Functions
  

  return (
    <div>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        {...props}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500,
          },
        }}
      >
        <Fade in={props.open}>
          <Box sx={style}>
            <Box
              sx={{
                color: "#919191",
                marginLeft: "auto",
              }}
              onClick={props.onClose}
            >
              <CancelIcon />
            </Box>
            <Box
              component="img"
              src={Image}
              sx={{ height: "250px", width: "280px" }}
            />
            <Typography
              id="transition-modal-title"
              variant="h5"
              component="h2"
              sx={{ fontWeight: "500", lineHeight: "2.421rem" }}
            >
              Verified Successfully
            </Typography>
            <Typography
              id="transition-modal-description"
              sx={{
                mt: 1,
                fontSize: "16px!important",
                color: "#626262",
                textAlign: "center",
              }}
            >
              Your account verified Successfully!
            </Typography>

            <Button
              onClick={handleOpen}
              className="loginButtonSignUp"
              variant="contained"
              color="primary"
              size="large"
              
              sx={{
                textTransform: "none",
                borderRadius: "10px",
                marginTop: "2rem!important",
                mb: "1rem",
              }}
            >
              <span className="buttonSignText">Create Smart Pin</span>
            </Button>
            <SmartPinModal open={open} onClose={handleClose} />
          </Box>
        </Fade>
      </Modal>
    </div>
  );
}
